var _g, _path, _path2, _path3, _path4, _path5, _path6, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlumbingSystem(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 108,
    height: 108,
    viewBox: "0 0 108 108",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_4_236)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 54,
    cy: 50,
    r: 50,
    fill: "white"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M59.1394 73.4844C55.5973 73.4809 52.2013 72.0723 49.6967 69.5677C47.192 67.0631 45.7834 63.6671 45.78 60.125V53.6504C45.7788 52.8596 45.464 52.1015 44.9047 51.5424C44.3454 50.9834 43.5872 50.6689 42.7964 50.6679H27.7039V40.2922H42.7988C46.3408 40.2959 49.7366 41.7046 52.2412 44.2091C54.7457 46.7137 56.1544 50.1096 56.1582 53.6515V60.125C56.1582 60.916 56.4724 61.6746 57.0317 62.2339C57.591 62.7932 58.3496 63.1074 59.1406 63.1074C59.9316 63.1074 60.6902 62.7932 61.2495 62.2339C61.8088 61.6746 62.123 60.916 62.123 60.125V28.1058H72.4988V60.125C72.4954 63.6671 71.0868 67.0631 68.5821 69.5677C66.0775 72.0723 62.6815 73.4809 59.1394 73.4844Z",
    fill: "#5f9098"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.9793 38.7981H27.5176C27.0807 38.7981 26.7266 39.1522 26.7266 39.5891V51.1497C26.7266 51.5865 27.0807 51.9407 27.5176 51.9407H30.9793C31.4162 51.9407 31.7703 51.5865 31.7703 51.1497V39.5891C31.7703 39.1522 31.4162 38.7981 30.9793 38.7981Z",
    fill: "#5f9098"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M57.5211 56.6984V53.2367C57.5211 52.7998 57.167 52.4457 56.7301 52.4457H45.1696C44.7327 52.4457 44.3785 52.7998 44.3785 53.2367V56.6984C44.3785 57.1353 44.7327 57.4894 45.1696 57.4894H56.7301C57.167 57.4894 57.5211 57.1353 57.5211 56.6984Z",
    fill: "#5f9098"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M73.877 48.7156V45.2539C73.877 44.817 73.5228 44.4629 73.0859 44.4629H61.5254C61.0885 44.4629 60.7344 44.817 60.7344 45.2539V48.7156C60.7344 49.1525 61.0885 49.5066 61.5254 49.5066H73.0859C73.5228 49.5066 73.877 49.1525 73.877 48.7156Z",
    fill: "#5f9098"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M73.877 29.3481V25.8864C73.877 25.4495 73.5228 25.0953 73.0859 25.0953H61.5254C61.0885 25.0953 60.7344 25.4495 60.7344 25.8864V29.3481C60.7344 29.7849 61.0885 30.1391 61.5254 30.1391H73.0859C73.5228 30.1391 73.877 29.7849 73.877 29.3481Z",
    fill: "#5f9098"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M39.234 52.6321C38.1653 53.5227 34.6743 56.6504 34.6813 61.0485C34.6813 62.1126 34.6813 64.1762 36.1789 65.2555C37.6766 66.3348 40.0907 66.0254 41.3668 64.6801C43.0075 62.9551 42.1778 60.1438 41.484 58.8583C40.9672 57.9032 40.5465 57.8305 39.9852 56.7829C39.1684 55.2583 39.1391 53.6926 39.234 52.6321Z",
    fill: "#5f9098"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_4_236",
    x: 0,
    y: 0,
    width: 108,
    height: 108,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0.372549 0 0 0 0 0.564706 0 0 0 0 0.596078 0 0 0 1 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.372549 0 0 0 0 0.564706 0 0 0 0 0.596078 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4_236"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_4_236",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlumbingSystem);
export default __webpack_public_path__ + "static/media/plumbingSystem.29193053225d781c7a1d43eb0eee5a2d.svg";
export { ForwardRef as ReactComponent };